


















































































import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { inject } from 'inversify-props';
import { InjectionIdEnum } from '@/enums/injection-id.enum';
import SessionService from '@/services/session.service';
import ProcessService from '@/services/crm/process.service';
import SettingsService from '@/services/crm/settings.service';
import SettingsModel from '@/models/crm/settings.model';
import { ClientTypeEnum } from '@/enums/client-type.enum';

interface IProcess {
  id?: number;
  idProcesso?: number;
  idFluxo: number;
  description: string;
  step: string;
  idFila: number;
  date: string;
  contact: string;
  allowDetail: boolean;
  hasFlowStep: boolean;
  hasFlowCurrentStep: boolean;
  etapaFinal?: boolean;
  resultado?: string;
  resultadoPositivo?: boolean;
  motivo?: string;
}

@Component({
  components: {},
})
export default class CardProcess extends Vue {
  @inject(InjectionIdEnum.SessionService)
  private sessionService!: SessionService;

  @inject(InjectionIdEnum.CrmProcessService)
  private processService!: ProcessService;

  @inject(InjectionIdEnum.CrmSettingsService)
  private settingsService!: SettingsService;

  @Prop()
  readonly processo!: IProcess;

  @Prop()
  readonly isConvertedProspect!: boolean;

  @Prop()
  readonly showEditProcess!: boolean;

  @Prop()
  readonly getKanbanUrl!: (processo: IProcess) => string;

  @Prop()
  readonly clientId!: string;

  @Prop()
  readonly clientType!: ClientTypeEnum;

  private settings: SettingsModel | null = null;

  @Emit('edit-process')
  onEditProcess(): IProcess {
    return this.processo;
  }

  async loadSettings(): Promise<void> {
    if (!this.settings) {
      try {
        this.settings = await this.settingsService.getSettings();
      } catch (error) {
        console.error('Erro ao carregar configurações:', error);
        this.settings = null;
      }
    }
  }

  async handleFollowClick(): Promise<void> {
    await this.loadSettings();

    if (this.settings?.flagHabilitaAbrirProcessoNoDialog) {
      await this.openProcessInModal();
      return;
    }

    await this.openProcessInNewTab();
  }

  private async openProcessInModal(): Promise<void> {
    this.$emit('open-process-modal', this.processo);
  }

  private async openProcessInNewTab(): Promise<void> {
    if (this.isBuiltInMode) {
      if (this.canGenerateBuiltInUrl()) {
        try {
          const builtInKanbanUrl = await this.generateBuiltInKanbanUrl();
          if (builtInKanbanUrl && builtInKanbanUrl !== '#') {
            window.open(builtInKanbanUrl, '_blank');
          } else if (this.getKanbanUrl && this.processo) {
            try {
              const fallbackUrl = this.getKanbanUrl(this.processo);
              window.open(fallbackUrl, '_blank');
            } catch (error) {
              this.$notify.error('Não foi possível abrir o processo. URL não disponível.');
            }
          } else {
            this.$notify.error('Não foi possível abrir o processo. URL não disponível.');
          }
        } catch (error) {
          this.$notify.error('Não foi possível abrir o processo. URL não disponível.');
        }
      } else if (this.getKanbanUrl && this.processo) {
        try {
          const fallbackUrl = this.getKanbanUrl(this.processo);
          window.open(fallbackUrl, '_blank');
        } catch (error) {
          this.$notify.error('Não foi possível abrir o processo. URL não disponível.');
        }
      } else {
        this.$notify.error('Não foi possível abrir o processo. URL não disponível.');
      }
    } else {
      const normalUrl = this.kanbanUrl;
      window.open(normalUrl, '_blank');
    }
  }

  canGenerateBuiltInUrl(): boolean {
    return !!(
      this.clientId
      && this.clientType
      && this.processo
      && this.processo.idFluxo
    );
  }

  async generateBuiltInKanbanUrl(): Promise<string> {
    if (!this.clientId || !this.clientType) {
      return '#';
    }

    try {
      if (this.sessionService?.apiUrl360) {
        const url = this.processService.getNewKanbanUrl(
          this.processo.idFluxo,
          this.clientId,
          this.clientType,
          this.processo.idFila,
          this.processo.id,
          true,
          undefined,
          true,
        );
        return url;
      }

      let kanbanUrl = '';

      try {
        const geo360Url = this.sessionService.apiUrl360;
        if (geo360Url) {
          kanbanUrl = `${geo360Url}/crm/processo`;
        } else {
          const currentOrigin = window.location.origin;
          kanbanUrl = `${currentOrigin}/crm/processo`;
        }
      } catch (e) {
        const currentOrigin = window.location.origin;
        kanbanUrl = `${currentOrigin}/crm/processo`;
      }

      kanbanUrl += `/${this.processo.id ? this.processo.id : '0'}`;
      kanbanUrl += `?idFluxo=${this.processo.idFluxo}`;
      kanbanUrl += `&tipoCliente=${ClientTypeEnum.Client.toString() === this.clientType
        ? 'CLIENTE' : this.clientType.toUpperCase()}`;
      kanbanUrl += `&idCliente=${this.clientId}`;
      kanbanUrl += `&filaPadrao=${this.processo.idFila}`;
      kanbanUrl += '&fromPainelRelacionamento=true';

      if (this.processService) {
        try {
          const token = this.processService.getApiToken();
          if (token) {
            kanbanUrl += `&token=${token}`;
          }

          const apiPath = this.processService.getApiPath();
          if (apiPath) {
            kanbanUrl += `&u=${apiPath}`;
          }
        } catch (e) {
          // Silent fail
        }
      }

      return kanbanUrl;
    } catch (error) {
      return '#';
    }
  }

  get statusColor(): string {
    if (this.processo.hasFlowCurrentStep) {
      return 'success';
    }
    if (this.processo.allowDetail && this.processo.hasFlowStep) {
      return 'warning';
    }
    return 'grey';
  }

  get statusTextColor(): string {
    if (this.processo.hasFlowCurrentStep || (this.processo.allowDetail && this.processo.hasFlowStep)) {
      return 'white';
    }
    return 'black';
  }

  get badgeColor(): string {
    if (this.processo.etapaFinal) {
      if (this.processo.resultado) {
        return this.processo.resultadoPositivo ? 'success' : 'error';
      }
      return 'warning';
    }
    return 'primary';
  }

  get showEncerradoTooltip(): boolean {
    return !!(this.processo.etapaFinal && !this.processo.resultado);
  }

  get kanbanUrl(): string {
    if (this.getKanbanUrl && this.processo) {
      const url = this.getKanbanUrl(this.processo);
      return url;
    }
    return '#';
  }

  get isBuiltInMode(): boolean {
    return this.sessionService && this.sessionService.builtInMode;
  }

  get badgeText(): string {
    if (this.processo.etapaFinal) {
      if (this.processo.resultado) {
        return this.processo.resultado;
      }
      return 'Encerrado';
    }
    return 'Em Andamento';
  }

  get statusIcon(): string {
    if (this.processo.hasFlowCurrentStep) {
      return 'mdi-check-circle';
    }
    if (this.processo.allowDetail && this.processo.hasFlowStep) {
      return 'mdi-clock';
    }
    return 'mdi-pause-circle';
  }

  get statusText(): string {
    if (this.processo.hasFlowCurrentStep) {
      return 'Ativo';
    }
    if (this.processo.allowDetail && this.processo.hasFlowStep) {
      return 'Pendente';
    }
    return 'Pausado';
  }
}
